import { bind } from 'decko'
import LiveNodeList from 'live-node-list'

export default class QuantityIncrementor {
  incrementors = new LiveNodeList('.quantity-incrementor')

  constructor() {
    this.registerListeners()
  }

  @bind
  registerListeners() {
    this.incrementors.forEach(this.initIncrementor)

    this.incrementors.on('update', (newItems, oldItems) => {
      newItems.forEach(this.initIncrementor)
    })

    this.incrementors.addDelegatedEventListener(
      document,
      'cart:processing:start',
      event => {
        this.incrementors.forEach(incrementor => {
          if ('lineItem' in event) {
            if (
              ('lineId' in incrementor.dataset &&
                parseInt(incrementor.dataset.lineId, 10) ===
                  event.lineItem?.lineId) ||
              ('productId' in incrementor.dataset &&
                parseInt(incrementor.dataset.productId, 10) ===
                  event.lineItem?.productId)
            ) {
              return this.disable(incrementor)
            }

            return
          }

          this.disable(incrementor)
        })
      },
    )

    this.incrementors.addDelegatedEventListener(
      document,
      'cart:processing:end',
      event => {
        this.incrementors.forEach(incrementor => {
          this.enable(incrementor)
        })
      },
    )

    this.incrementors.addDelegatedEventListener(document, 'cart:error', _ => {
      this.incrementors.forEach(incrementor => {
        this.enable(incrementor)
      })
    })
  }

  @bind
  disable(incrementor) {
    incrementor.querySelectorAll('button, input').forEach(item => {
      item.setAttribute('disabled', 'disabled')
    })
  }

  @bind
  enable(incrementor) {
    incrementor.querySelectorAll('button, input').forEach(item => {
      item.removeAttribute('disabled')
    })
  }

  @bind
  initIncrementor(incrementor) {
    const plus = incrementor.querySelector('.quantity-incrementor__plus')
    const minus = incrementor.querySelector('.quantity-incrementor__minus')
    const input = incrementor.querySelector('.quantity-incrementor__input')
    const lineId = parseInt(incrementor.dataset.lineId, 10)

    let min
    let max
    let step

    const resetMinMax = () => {
      min = parseInt(input.getAttribute('min'), 10)
      max = parseInt(input.getAttribute('max'), 10)
      step = parseInt(input.getAttribute('step'), 10)

      if (isNaN(min)) {
        min = 1
      }
      if (isNaN(step) || step < 1) {
        step = 1
      }
      if (isNaN(max)) {
        max = 999
      }
    }

    const minmax = value => {
      if (value < min) {
        return min
      }

      if (value % step !== 0) {
        return Math.ceil(value / step) * step
      }

      if (value > max) {
        return max
      }

      return value
    }

    const updateButtonState = () => {
      if (max === 0) {
        ;[input, minus, plus].forEach(item => {
          item.setAttribute('disabled', 'disabled')
        })
      } else {
        ;[input, minus, plus].forEach(item => {
          item.removeAttribute('disabled')
        })
      }

      if (parseInt(input.value, 10) === min) {
        minus.setAttribute('disabled', 'disabled')
      } else {
        minus.removeAttribute('disabled')
      }

      if (parseInt(input.value, 10) === max) {
        plus.setAttribute('disabled', 'disabled')
      } else {
        plus.removeAttribute('disabled')
      }
    }

    plus.addEventListener('click', e => {
      e.preventDefault()
      clearTimeout(this.timer)

      let value = parseInt(input.value, 10)
      value = isNaN(value) ? min : value
      value += step
      input.value = minmax(value)
      input.dispatchEvent(new Event('change'))
    })

    minus.addEventListener('click', e => {
      e.preventDefault()
      clearTimeout(this.timer)

      let value = parseInt(input.value, 10)
      if (value > 0) {
        value = isNaN(value) ? min : value
        value -= step
        input.value = minmax(value)
        input.dispatchEvent(new Event('change'))
      }
    })

    input.addEventListener('keyup', e => {
      e.preventDefault()
      clearTimeout(this.timer)

      let value = parseInt(input.value, 10)

      input.value = minmax(value)
      input.dispatchEvent(new Event('change'))
    })

    input.addEventListener('change', e => {
      if (parseInt(input.value, 10) === min) {
        minus.setAttribute('disabled', 'disabled')
      } else {
        minus.removeAttribute('disabled')
      }

      if (parseInt(input.value, 10) === max) {
        plus.setAttribute('disabled', 'disabled')
      } else {
        plus.removeAttribute('disabled')
      }

      updateButtonState()
      this.updateSiteCart(lineId, parseInt(input.value, 10))

      input
        .closest('[data-product-form]')
        ?.dispatchEvent(new Event('product:quantity:change'))
    })

    const form = input.closest('form')
    if (form) {
      form.addEventListener('product:variant:change', event => {
        resetMinMax()
        updateButtonState()

        let value = parseInt(input.value, 10)
        input.value = minmax(value)
        input.dispatchEvent(new Event('change'))
      })
    }

    resetMinMax()
    updateButtonState()
  }

  @bind
  async updateSiteCart(lineId, value) {
    if (lineId) {
      this.timer = setTimeout(e => {
        window.app.components.cartApi.updateLineItem(lineId, value)
      }, 500)
    }
  }
}
